'use strict';

var AppState = require('app_state');
var StandardTileView = require('components/dashboard/views/standard_tile_view');

var ChangelogView = StandardTileView.extend({
    template: require('components/dashboard/templates/changelog'),

    ui: {
        next: '#js-next',
        previous: '#js-prev',
    },

    events: {
        'click @ui.next, @ui.previous': 'changeVersion',
    },

    initialize: function (options) {
        this.lang = AppState.getUserLanguage();
    },

    serializeData: function () {
        return this.options;
    },

    onRender: function () {
        $('.changelog-container').slimScroll({
            height: '100%',
            railVisible: true,
        });
    },

    changeVersion: function (version) {
        var self = this;
        var source = '/info/update_v' + version + '_' + this.lang + '.json';
        $.getJSON(source, function (spec) {
            self.options = spec;
            self.updateFooter();
            self.updateHeader();
            self.render();
        }).fail(function (params) {
            console.log('could not get next changelog');
        });
    },

    getHeaderConfiguration: function () {
        return { title: this.options.title + ' - v' + this.options.meta.display_version };
    },

    getFooterConfiguration: function () {
        return {
            leftButtons: [
                {
                    id: 'js-prev-' + this.cid,
                    class: this.options.meta.prev ? '' : ' disabled',
                    icon: 'fa fa-arrow-left',
                },
                {
                    id: 'js-next-' + this.cid,
                    class: this.options.meta.next ? '' : ' disabled',
                    icon: 'fa fa-arrow-right',
                },
            ],
            text: this.options.footer,
        };
    },

    handleFooterAction: function (action) {
        var actionType = action.split('-')[1];
        switch (actionType) {
            case 'prev':
                this.changeVersion(this.options.meta.prev);
                break;
            case 'next':
                this.changeVersion(this.options.meta.next);
                break;
            default:
                // unkown action, should not happen
                Log.assert(false);
        }
    },
});

module.exports = {
    getTileView: function (data) {
        return new ChangelogView(data);
    },
};
